import { useEffect, useState } from 'react';
import LandingPage from './LandingPage.js';
import ChickenPage from './ChickenPage.js';
import ChickenList from './ChickenList.js';
import { ethers } from 'ethers';
import './App.css';
import Loading from './Loading';
import {
  useParams,
  Routes,
  Route,
  useLocation,
  matchPath,
  useNavigate
} from "react-router-dom";
import ButtonTst from './ButtonTst.js';
import Galary from './Galary.js';
import detectEthereumProvider from '@metamask/detect-provider'


const ChickenContractAddress = '0xaFc828Bb75Dfc4E4561FcA00e2C52029DC295abc';
const EggDistributorAddress = '0xf03321a31275EffB601cC645985FD2CE9a1F7149';
const GoldenEggAddress = '0x134597599A7aB4faD1A2DD72ABA872a6abf62b03';

function App() {
  var pathname = useLocation().pathname;
  var tokenId = '0';
  var matchedPath = matchPath({ path: '/:tokenId' }, pathname);
  var tokenId = matchedPath ? matchedPath.params.tokenId : '0';
  tokenId = /^\+?(0|[1-9]\d*)$/.test(tokenId) ? tokenId : '0';
  const [currentAccount, setCurrentAccount] = useState(null);
  const [queryTokenId, setQueryTokenId] = useState(tokenId);
  const [claimablEth, setClaimablEth] = useState(0);
  const [claimablEgg, setClaimablEgg] = useState(0);
  const [baseEgg, setBaseEgg] = useState(0);
  const [metadata, setMetadata] = useState(null);
  const [owner, setOwner] = useState('');
  const [offspringCount, setOffspringCount] = useState(0);
  const [latestTokenId, setLatestTokenId] = useState(0); // so latestTokenId + 1 is the total num. of Chicken
  const [multiplier, setMultiplier] = useState(100);
  const [baseBonus, setBaseBonus] = useState(0);
  const [allChicken, setAllChicken] = useState([]);
  const [loading, setLoading] = useState(false);

  const ChickenAbi = require('./contracts/Chicken.json').abi;
  const EggDistributorAbi = require('./contracts/EggDistributor.json').abi;
  const GoldenEggAbi = require('./contracts/GoldenEgg.json').abi;
  const providerUrl = "wss://mainnet.infura.io/ws/v3/9ad678ce18b94752b83698da4fdcb705";
  //tst "wss://rinkeby.infura.io/ws/v3/9ad678ce18b94752b83698da4fdcb705"

  const navigate = useNavigate();

  const getNftContract = () => {
    const provider = new ethers.providers.WebSocketProvider(providerUrl);

    const contract = new ethers.Contract(
      ChickenContractAddress,
      ChickenAbi,
      provider
    );
    return contract;
  }

  const getEggDistributorContract = () => {
    const provider = new ethers.providers.WebSocketProvider(providerUrl);

    const contract = new ethers.Contract(
      EggDistributorAddress,
      EggDistributorAbi,
      provider
    );
    return contract;
  }

  const getSignedNftContract = () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const nftContract = new ethers.Contract(ChickenContractAddress, ChickenAbi, signer);
      return nftContract;
    } catch (err) {
      console.log(err)
    }
  }

  const getSignedEggDistributorContract = async () => {
    try {
      //const provider = new ethers.providers.WebSocketProvider(providerUrl);
      const provider = new ethers.providers.Web3Provider(window.ethereum)
      //const provider = await detectEthereumProvider();
      const signer = provider.getSigner();
      const distributorContract = new ethers.Contract(EggDistributorAddress, EggDistributorAbi, signer);
      return distributorContract;
    } catch (err) {
      console.log(err)
    }
  }

  const connectWalletHandler = async () => {
    const provider = await detectEthereumProvider();

    if (!provider) {
      alert("Please install Metamask!");
    } else {
      //API.ethereum = ethereum;
    }

    try {
      const accounts = await provider.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (err) {
      console.log(err)
    }
  }

  const fetchClaimablEth = async () => {
    try {
      const nftContract = getNftContract();
      const nftTxn = await nftContract.checkBonus(queryTokenId, {});
      console.log("Quering... please wait");
      //await nftTxn.wait();
      //alert("ClaimablEth " + nftTxn / 1000000000000000000 + " eth")
      setClaimablEth(nftTxn / 1000000000000000000)
      console.log('fetchClaimablEth:', claimablEth, nftTxn)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchOwner = () => {
    try {
      const nftContract = getNftContract();
      const ownerWallet = nftContract.ownerOf(queryTokenId);
      ownerWallet.then((o) => {
        console.log('setOwner ', o)
        setOwner(o);
      }).catch((err) => {
        alert(`Chicken #${queryTokenId} not exist, back to home page`);
        navigate("/");
      });

    } catch (err) {
      //if (this.navigate)this.
      navigate("/");
      console.log(err);
    }
  }

  const isOwner = () => {
    if (currentAccount && owner) {
      return owner.toUpperCase() == currentAccount.toUpperCase();
    }
    return false;
  }

  const fetchClaimableEggToken = async () => {
    try {
      const distributorContract = getEggDistributorContract();
      const amount = await distributorContract.checkBonus(queryTokenId);
      console.log("fetching..." + amount);
      //alert("Token have " + amount / 1000000000000000000 + " egg bonus")
      setClaimablEgg(amount / 1000000000000000000)
      console.log('fetchClaimableEggToken:', claimablEgg)

    } catch (err) {
      console.log('fetchClaimableEggToken', err)
      //alert(err.data.message)
    }
  }

  const fetchEggTokenInConnectedWallet = async () => {
    const provider = await detectEthereumProvider();

    if (!provider) {
      alert("Please install Metamask!");
    }

    try {
      const signer = provider.getSigner();
      const eggContract = new ethers.Contract(GoldenEggAddress, GoldenEggAbi, signer);

      const amount = await eggContract.balanceOf(currentAccount);
      console.log("fetching..." + amount + currentAccount);

    } catch (err) {
      console.log('fetchEggTokenInConnectedWallet', err)
      //alert(err.data.message)
    }
  }


  const mintNftHandler = async () => {
    try {
      const nftContract =  getSignedNftContract();
      console.log("Initialize payment");

      let nftTxn = await nftContract.publicMint(queryTokenId, { value: ethers.utils.parseEther("0.01") });

      console.log("Mining... please wait");
      setLoading(true);
      await nftTxn.wait();

      // call metat data to generate chicken png
      console.log(`Mined, see transaction: ${nftTxn.hash}`);
      console.log(nftTxn)
      nftContract.once("Minted", function (error, event) {
        setLoading(false);
        console.log("minted")
        console.log(event)
        const mintedTokenId = parseInt(event._hex, 16);

        navigate(`/${mintedTokenId}`);
      })

    } catch (err) {
      console.log(err);
    }
  }

  const freeMintNftHandler = async () => {
    try {
      const nftContract = getSignedNftContract();
      console.log("Initialize payment");

      let nftTxn = await nftContract.freeMint();

      console.log("Mining... please wait");
      setLoading(true);
      await nftTxn.wait();

      // call metat data to generate chicken png
      console.log(`Mined, see transaction: ${nftTxn.hash}`);
      console.log(nftTxn)
      nftContract.once("Minted", function (error, event) {
        setLoading(false);
        console.log("minted")
        console.log(event)
        const mintedTokenId = parseInt(event._hex, 16);

        navigate(`/${mintedTokenId}`);
      })

    } catch (err) {
      console.log(err);
    }
  }

  const claimEthTokenHandler = async () => {
    if (!isOwner()) {
      console.log('not owner');
      return;
    }
    console.log("claimEthTokenHandler called");

    try {
      const nftContract = getSignedNftContract();

      const nftTxn = await nftContract.claimBonus(queryTokenId);
      console.log("Claiming eth... please wait");
      await nftTxn.wait();
      alert("token eth claimed")

    } catch (err) {
      console.log('claimEthTokenHandler', err)
      //alert(err.data.message)
    }
  }

  const ClaimEggTokenHandler = async () => {
    if (!isOwner()) {
      console.log('not owner');
      return;
    }

    try {
      const distributorContract = getSignedEggDistributorContract();

      const nftTxn = await distributorContract.claimBonus(queryTokenId);
      console.log("Claiming... please wait");
      await nftTxn.wait();
      alert("egg token claimed")

    } catch (err) {
      console.log('ClaimEggTokenHandler', err)
      //alert(err.data.message)
    }
  }

  const checkWalletIsConnected = async () => {
    const provider = await detectEthereumProvider();

    if (!provider) {
      console.log("Make sure you have Metamask installed!");
      return;
    } else {
      console.log("Wallet exists! We're ready to go!")
    }

    const accounts = await provider.request({ method: 'eth_accounts' });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account: ", account);
      setCurrentAccount(account);
    } else {
      console.log("No authorized account found");
    }
  }

  const fetchMetadata = () => {
    console.log('fetchMetadata');
    async function fetchData() {
      const response = await fetch(`/metadata/${queryTokenId}`);
      const json = await response.json();
      setMetadata(json);
      console.log('metadata:', metadata)
    }

    fetchData();
  };

  const fetchAllChickenBy = (wallet) => {
    const nftContract = getNftContract();
    const promiseList = []

    fetchLatestTokenId().then((total) => {
      for (var i = 0; i <= total; i++) {
        promiseList.push(nftContract.ownerOf(i));
      }

      Promise.all(promiseList).then((ownerList) => {
        const ownedNtdId = []
        for (var i = 0; i < ownerList.length; i++) {
          if (ownerList[i] && wallet && ownerList[i].toUpperCase() == wallet.toUpperCase()) {
            ownedNtdId.push(i)
          }
        }

        setAllChicken(ownedNtdId)
      });
    });

  }

  const fetchAllChicken = () => {
    fetchAllChickenBy(currentAccount);
  }

  const fetchOffspringCount = () => {
    const nftContract = getNftContract();
    nftContract.getOffspringCount(queryTokenId)
      .then((offspring) => {
        offspring = parseInt(offspring._hex, 16);
        console.log(`setOffspring ${queryTokenId}:`, offspring);
        setOffspringCount(offspring);
      });
  }

  const fetchMultiplier = () => {
    const contract = getEggDistributorContract();
    contract.getMultiplier(queryTokenId).then((multiplier) => {
      multiplier = parseInt(multiplier._hex, 16) / 100;
      console.log('setMultiplier', multiplier);
      setMultiplier(multiplier);
    });
  }

  const fetchBaseBonus = () => {
    const contract = getEggDistributorContract();
    contract.getBaseBonus(queryTokenId).then((b) => {
      b = parseInt(b._hex, 16);
      b = b / Math.pow(10, 14)
      console.log('setBaseBonus', b);
      setBaseBonus(b);
    });
  }

  const fetchLatestTokenId = async () => {
    const nftContract = getNftContract();
    var total = await nftContract.getCurrentTokenIdCounter();
    total = parseInt(total._hex, 16) - 1; // the counter in api is for next chicken so -1
    console.log('setLatestTokenId', total);
    setLatestTokenId(total);
    return total;
  }

  useEffect(() => {
    checkWalletIsConnected();
    fetchLatestTokenId();
  }, []);

  const API = {
    ChickenAbi,
    getNftContract,
    getSignedNftContract,
    getEggDistributorContract,
    currentAccount,
    connectWalletHandler,
    checkWalletIsConnected,
    fetchEggTokenInConnectedWallet,
    mintNftHandler,
    setQueryTokenId,
    queryTokenId,
    fetchClaimablEth,
    fetchClaimableEggToken,
    claimablEth,
    claimablEgg,
    baseEgg,
    claimEthTokenHandler,
    ClaimEggTokenHandler,
    fetchMetadata,
    fetchOwner,
    isOwner,
    owner,
    metadata,
    fetchOffspringCount,
    offspringCount,
    fetchMultiplier,
    multiplier,
    fetchLatestTokenId,
    latestTokenId,
    fetchBaseBonus,
    baseBonus,
    fetchAllChicken,
    fetchAllChickenBy,
    allChicken,
    freeMintNftHandler,
    loading,
    ethers
  }

  window.API = API;

  return (
    <div className='main-app'>

      <Routes>
        <Route exact path="/" element={<LandingPage api={API} />} />
        <Route exact path="/free" element={<LandingPage api={API} free={true}/>} />
        <Route exact path="/galary" element={<Galary api={API} />} />
        <Route path="/:tokenId" element={<ChickenPage api={API} />} />
        <Route path="/wallet/:walletAddress" element={<ChickenList api={API} />} />
        <Route exact path="/tst" element={<ButtonTst />} />
      </Routes>
      {loading && <Loading />}
    </div>
  )
}

export default App;
